import React from 'react';
import SuperAdminLayout from '../../components/admin/SuperAdminLayout';
import SEOScoringAdmin from '../../components/admin/SEOScoringAdmin';

const SEOScoringPage: React.FC = () => {
  return (
    <SuperAdminLayout>
      <SEOScoringAdmin />
    </SuperAdminLayout>
  );
};

export default SEOScoringPage;